import { Component, Input, OnInit } from '@angular/core';
import { MANUAL_CNS } from 'src/app/app.api';

@Component({
  selector: 'app-botao-ajuda',
  templateUrl: './botao-ajuda.component.html',
  styleUrls: ['./botao-ajuda.component.css']
})
export class BotaoAjudaComponent implements OnInit {

  constructor() { }

  @Input() public manual: string;
  @Input() public titleAjuda: string;
  @Input() public telaConsulta: boolean;

  ngOnInit() {
  }

  
  get urlManual(): string {
    return MANUAL_CNS;
  }

  abrirAjuda(manualCNS: string){
    window.open(this.urlManual.concat('/'+manualCNS), '_blank');
  }

}
